<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="费用ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入费用ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="费用名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入费用名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="项目来源">
              <el-select v-model="queryParams.funding_type" placeholder="请选择项目来源" @change="search" clearable class="w100">
                <el-option label="自营" value="1"></el-option>
                <el-option label="分销" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="业务分类">
              <el-select v-model="queryParams.funding_type_id" filterable placeholder="请选择业务分类" @change="search" clearable class="w100">
                <el-option v-for="dict in fundingTypeList" :key="dict.id" :label="dict.name" :value="dict.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="收支类型">
              <el-select v-model="queryParams.trade_type" placeholder="请选择收支类型" @change="search" clearable class="w100">
                <el-option label="收入" value="1"></el-option>
                <el-option label="支出" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="收支名称">
              <el-select v-model="queryParams.trade_type_id" placeholder="请选择收支名称" filterable @change="search" clearable class="w100">
                <el-option v-for="dict in tradeTypeList" :key="dict.id" :label="dict.name" :value="dict.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
            <el-form-item label="交易时间">
              <el-date-picker
                  v-model="queryParams.trade_time"
                  style="width: 100%;"
                  type="daterange"
                  unlink-panels
                  align="right"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="headerChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="关联团队">
              <el-select v-model="queryParams.team_id" filterable @change="search" placeholder="请选择关联团队" clearable style="width: 100%;">
                <el-option v-for="dict in teamList" :key="dict.id" :label="dict.name" :value="dict.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="关联主体" prop="subject_id">
              <el-select v-model="queryParams.subject_id" filterable @change="search" placeholder="请选择关联主体"
                         style="width: 100%;" clearable>
                <el-option v-for="dict in subjectList" :key="dict.id" :label="dict.name"
                           :value="dict.id"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说项目">
              <el-input v-model="queryParams.short_play_project_name" @change="search" placeholder="请输入小说项目名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>
                    
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="录入方式">
              <el-select v-model="queryParams.source" placeholder="请选择录入方式" @change="search" clearable class="w100">
                <el-option label="手动" value="1"></el-option>
                <el-option label="自动" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="执行状态">
              <el-select v-model="queryParams.execution_status" placeholder="请选择执行状态" @change="search" clearable class="w100">
                <el-option label="未执行" value="0"></el-option>
                <el-option label="已执行" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" size="medium" border
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                show-summary :summary-method="getSummaries" sum-text="汇总" v-loading="loading">
        <el-table-column label="ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="费用名称" width="300px">
          <template slot-scope="scope">{{ scope.row.fee_name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="项目来源">
          <template slot-scope="scope">{{ scope.row.funding_type_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="业务分类">
          <template slot-scope="scope">{{ scope.row.funding_type_name_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="收支类型">
          <template slot-scope="scope">{{ scope.row.trade_type_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="收支名称">
          <template slot-scope="scope">{{ scope.row.trade_type_name_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="交易金额">
          <template slot-scope="scope">{{ scope.row.amount }}</template>
        </el-table-column>

        <el-table-column prop="name" label="交易时间">
          <template slot-scope="scope">{{ scope.row.trade_time }}</template>
        </el-table-column>

        <el-table-column prop="name" label="关联团队">
          <template slot-scope="scope">{{ scope.row.team_name_text }}</template>
        </el-table-column>
        
        <el-table-column prop="name" label="关联小说项目">
          <template slot-scope="scope">{{ scope.row.short_play_project_name_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="关联主体">
          <template slot-scope="scope">{{ scope.row.subject_name_text }}</template>
        </el-table-column>
        
        <el-table-column prop="name" label="录入方式">
          <template slot-scope="scope">{{ scope.row.source_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="执行状态">
          <template slot-scope="scope">{{ scope.row.execution_status_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="执行时间">
          <template slot-scope="scope" v-if="scope.row.execution_status==1">{{ scope.row.execution_time }}</template>
        </el-table-column>

        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList('changePage')"/>
      <FundingOrderEdit v-if="AddFundingOrderFlag" :AddFundingOrderFlag="AddFundingOrderFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                    :editID="editID">
      </FundingOrderEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import FundingOrderEdit from "./edit.vue"

export default {
  components: {
    FundingOrderEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:''
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddFundingOrderFlag: false,
      loading: false,
      fundingTypeList:[],
      tradeTypeList:[],
      total_amount : 0,
      subjectList: [],
      teamList: [],//团队列表


    };
  },
  created() {
    this.getfundingTypeList()
    this.gettradeTypeList()
    this.getSelectList()
    this.getList()
  },
  methods: {
    getSelectList() {
      let api = MoneyManagementAPI()

      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          this.subjectList = res.data
        } else {
          processErrors(res);
        }
      })

      api.getTeamSelect({status:-1}).then(res=>{
        this.teamList = res.data
      })
    },

    getSummaries() {
      const sums = [];
      sums[0] = '汇总';
      sums[1] = '';
      sums[2] = '';
      sums[3] = '';
      sums[4] = '';
      sums[5] = '';
      sums[6] = this.total_amount;
      sums[7] = '';
      sums[8] = '';
      sums[9] = '';
      sums[10] = '';
      return sums;
    },

    gettradeTypeList() {
      let api = MoneyManagementAPI()
      api.getTradeTypeSelect().then(res => {
        if (res.code == 0) {
          this.tradeTypeList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    getfundingTypeList() {
      let api = MoneyManagementAPI()
      api.getFundingTypeSelect().then(res => {
        if (res.code == 0) {
          this.fundingTypeList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    headerChange(e) {
      if (Array.isArray(e) && e.length === 2) {
        // 将日期字符串转换为 Date 对象
        const date = new Date(e[0]);
        const dates = new Date(e[1]);

        // 检查 date 和 dates 是否为有效的 Date 对象
        if (!isNaN(date) && !isNaN(dates)) {
          const year = date.getFullYear();
          const years = dates.getFullYear();
          const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
          const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
          const day = ('0' + date.getDate()).slice(-2);
          const days = ('0' + dates.getDate()).slice(-2);
          const time = '00:00:00';
          const times = '23:59:59';
          const formattedDate = `${year}-${month}-${day} ${time}`;
          const formattedDates = `${years}-${months}-${days} ${times}`;
          this.queryParams.trade_time = [formattedDate, formattedDates];
        } else {
          console.error('Invalid date objects:', date, dates);
        }
      }
      this.search();
    },

    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      let api = MoneyManagementAPI()
      api.getFundingOrderList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
          this.total_amount = res.data.total_amount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:''
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddFundingOrderFlag = true
    },
    NoneDlog() {
      this.AddFundingOrderFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddFundingOrderFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddFundingOrderFlag = true
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
::v-deep .el-table {
  display: flex;
  flex-direction: column;
  .el-table__cell {
    text-align: center;
  }
}

/* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
::v-deep .el-table__body-wrapper {
  order: 1;
}

::v-deep .el-table__fixed-body-wrapper {
  top: 96px !important;
}

::v-deep .el-table__fixed-footer-wrapper {
  z-index: 0;
}
</style>